import "./Home.module.css";
import EstateHeader from "@/reusable_sections/Header";
import TheVelvetHorizon from "./sections/TheVelvetHorizon";
import TheArtOfTheCrush from "./sections/TheArtOfTheCrush";
import EstateExperiences from "./sections/EstateExperiences";
import VineyardVistas from "./sections/VineyardVistas";
import EstateFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <EstateHeader />
      <TheVelvetHorizon />
      <TheArtOfTheCrush />
      <EstateExperiences />
      <VineyardVistas />
      <EstateFooter />
    </div>;
}